"use client";
import React from "react";
import Logo from "../../assets/Logo-red.svg"; 
import qrCode from "../../assets/qrCode.svg";
import Pill from "../common/Pill";

const TryItNow = () => {
  return (
   <section className="bg-[#FFF7EB] py-16 text-center md:text-left">
  <div className="max-w-6xl mx-auto flex flex-col items-center gap-10 md:gap-16 px-8 md:px-12">
    
    {/* Heading Section */}
    <div className="flex flex-col items-center text-center">
      <div className="flex justify-center">
        <Pill text="Try It Now" backgroundColor="#F3E6E6" />
      </div>
      <h2 className="mt-4 text-4xl md:text-5xl font-bold bg-gradient-to-r from-[#272020] to-[#690101] bg-clip-text text-transparent py-1.5">
        Talk to Our AI Agent
      </h2>
      <p className="mt-3 text-sm md:text-base text-gray-600 leading-relaxed">
        Scan the QR code below and experience how AgoraVoice works. <br />
        Instant, human-like answers on your phone in seconds.
      </p>
    </div>

    {/* QR + Info Section */}
    <div className="flex flex-col sm:flex-row   gap-8 w-full max-w-6xl mx-auto">
      
      {/* QR Card */}
      <div className="flex items-center justify-center rounded-xl bg-gradient-to-b from-[#3B0A0A] to-[#180404] sm:h-[360px] sm:w-[470px] w-full max-w-[470px] p-[24px]">
        <img
          src={qrCode}
          alt="AgoraVoice QR Code"
          width={200}
          height={200}
          className="rounded-lg"
        />
      </div>

      {/* Text Info Card */}
      <div className="flex flex-col justify-between bg-[#FFFFFF] rounded-xl overflow-hidden w-full max-w-[470px] p-[24px]">
        <div>
          <p className="text-[22px] sm:text-[26px] md:text-[28px] font-bold bg-gradient-to-r from-[#272020] to-[#690101] bg-clip-text text-transparent leading-snug">
            Open Your Smartphone Camera → Scan QR Code → Talk To AI Agent
          </p>
          <p className="text-sm text-gray-500 mt-2">
            No app needed. Works instantly on any smartphone.
          </p>
        </div>

        <div className="flex flex-col sm:items-start items-center gap-2 mt-6 px-2 py-2 bg-[#f5f5f5] rounded-md">
          <img src={Logo} alt="agent icon" className="w-auto h-[32px]" />
          <p className="sm:text-[14px] text-[12px] text-[#5C5A5A]">
            See the power of AgoraVoice on your phone.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

  );
};

export default TryItNow;
